import { render } from "./Display.vue?vue&type=template&id=3c9922ca&scoped=true&ts=true"
import script from "./Display.vue?vue&type=script&lang=ts"
export * from "./Display.vue?vue&type=script&lang=ts"

import "./Display.vue?vue&type=style&index=0&id=3c9922ca&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3c9922ca"]])

export default __exports__